import { beautify, formatDate } from "../../utils/helpers";

export const useRejectedApplicationUsers = () => {
  const tableColumns = () => [
    {
      id: "application_number",
      header: "Application Number",
      filter: {},
    },
    {
      id: "first_name",
      header: "First Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "last_name",
      header: "Last Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "email",
      header: "Email",
      filter: {
        type: "text",
      },
    },
    {
      id: "phone_number",
      header: "Phone Number",
      filter: {
        type: "text",
      },
    },
    {
      id: "rejection_reason",
      header: "Rejection Reason",
    },
    {
      id: "role",
      header: "Role",
      filter: {
        type: "text",
        key: "role_name",
      },
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      // const nameParts = item.application_data.taxpayer_name.split(" ");
      const row = {
        ...item,
        phone_number: item?.application_data?.phone_number,
        first_name:
          item?.application_data?.first_name ||
          (item.application_data.taxpayer_name.split(" ").length === 3
            ? `${item.application_data.taxpayer_name.split(" ")[0]} ${item.application_data.taxpayer_name.split(" ")[1]}`
            : item.application_data.taxpayer_name.split(" ")[0]),

        last_name:
          item?.application_data?.last_name ||
          (item.application_data.taxpayer_name.split(" ").length === 3
            ? item.application_data.taxpayer_name.split(" ")[2]
            : item.application_data.taxpayer_name.split(" ")[1]),
        date_joined: formatDate(item.date_joined),
        email: item?.application_data.email,
        role: beautify(item?.role_name),
      };
      return row;
    }),
  ];

  const tableTitle = "Rejected Users";

  return {
    tableColumns,
    tableData,
    tableTitle,
  };
};
